<script setup lang="ts">
import DemoDataTable from '@/features/sales/components/DemoDataTable.vue'

definePage({
  path: '/sales/sales-metrics/all-demos',
  name: '/sales/SalesMetrics/all-demos',
  meta: {
    permission: {
      resource: 'SalesMetrics',
      level: 'Read',
    },
  },
})
</script>

<template>
  <Card>
    <template #content>
      <DemoDataTable
        storage-key="sales-all-demos"
        :show-sales-person-column="true"
        :show-sales-person-filter="true"
      />
    </template>
  </Card>
</template>
